import DocumentActions from './parts/document-actions';
import MoveDocumentsControl from './parts/move-documents-control';
import { DocumentsControlsTypes } from './types';

import cn from './styles.module.css';

const DocumentsControls = ({
  setMenuVisible,
  menuVisible,
  moveInProgress,
  selectedCategory,
  allDocumentsSelected,
  selectedDocumentsCountByCategory,
  allowedCategories,
  documentsByCategoryId,
  allDocuments,
  changeCustomerDocumentsCategoryAction,
  otherActionsMenuVisible,
  type,
  setOtherActionsMenuVisible,
  activePermissions,
  statusChangeInProgress,
  setSelectedStatus,
  changeCustomerDocumentsStatusAction,
  selectedStatus,
  setDeletePopupVisible,
  getFiles,
  downloadInProgress,
  isFetching,
}: DocumentsControlsTypes) => (
  <div className={cn.selectedDocumentsControls}>
    <MoveDocumentsControl
      setMenuVisible={setMenuVisible}
      menuVisible={menuVisible}
      moveInProgress={moveInProgress}
      selectedCategory={selectedCategory}
      allDocumentsSelected={allDocumentsSelected}
      selectedDocumentsCountByCategory={selectedDocumentsCountByCategory}
      allowedCategories={allowedCategories}
      documentsByCategoryId={documentsByCategoryId}
      allDocuments={allDocuments}
      changeCustomerDocumentsCategoryAction={
        changeCustomerDocumentsCategoryAction
      }
    />
    <DocumentActions
      otherActionsMenuVisible={otherActionsMenuVisible}
      type={type}
      setOtherActionsMenuVisible={setOtherActionsMenuVisible}
      activePermissions={activePermissions}
      statusChangeInProgress={statusChangeInProgress}
      setSelectedStatus={setSelectedStatus}
      allowedCategories={allowedCategories}
      documentsByCategoryId={documentsByCategoryId}
      allDocuments={allDocuments}
      changeCustomerDocumentsStatusAction={changeCustomerDocumentsStatusAction}
      selectedStatus={selectedStatus}
      setDeletePopupVisible={setDeletePopupVisible}
      getFiles={getFiles}
      downloadInProgress={downloadInProgress}
      isFetching={isFetching}
    />
  </div>
);

export default DocumentsControls;
